"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientDateOverride_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientDateOverride_Factory = /** @class */ (function () {
    function PatientDateOverride_Factory() {
    }
    PatientDateOverride_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            FirstVisit: Date_Factory_1.Date_Factory.CreateIncoming(model.FirstVisit, { ignoreTimePortion: true }),
            LastBitewing: Date_Factory_1.Date_Factory.CreateIncoming(model.LastBitewing, { ignoreTimePortion: true }),
            LastPanoFMX: Date_Factory_1.Date_Factory.CreateIncoming(model.LastPanoFMX, { ignoreTimePortion: true }),
            RecordId: model.RecordId,
        };
        return result;
    };
    PatientDateOverride_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            FirstVisit: Date_Factory_1.Date_Factory.CreateOutgoing(model.FirstVisit, { ignoreTimePortion: true }),
            LastBitewing: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastBitewing, { ignoreTimePortion: true }),
            LastPanoFMX: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastPanoFMX, { ignoreTimePortion: true }),
            RecordId: model.RecordId,
        };
        return result;
    };
    return PatientDateOverride_Factory;
}());
exports.PatientDateOverride_Factory = PatientDateOverride_Factory;
